module.exports = __webpack_public_path__ + "img/user_symbol.e42f0898.svg";